module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("7")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("W")]), _vm._v("hen Owen Hansen had first brought his book of business to Recursos Empresariales Internationales at number 18 Vía Israel in Panama City, Panama, he didn’t win any popularity contests. The people who worked there discovered that as a client he was demanding, exacting, and unreasonable. He ran through three different account managers in very short order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of all the account reps who worked for Arturo Salazar, Graciella Miramar was by far the top producer, but that didn’t make her Arturo’s favorite, not by any means. For one thing, he’d been pressured into hiring her by none other than one of his best customers, Felix Duarte, who had then insisted that his accounts be assigned to this dowdy new hire. Arturo wondered about why El Pescado would take such a singular interest in someone like Graciella, who was the antithesis of hot. Arturo’s initial assumption was that she must have slept with Felix, but when she absolutely rebuffed Arturo’s own amorous advances, he revised that suspicion and settled on the idea that Graciella had something else on Felix that he wanted kept quiet. In Arturo’s playbook, if sex wasn’t the answer, blackmail was always an excellent alternative.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Faced with the dilemma of retaining a valuable but difficult new customer while at the same time preventing a revolt among ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("his unhappy employees, Arturo had passed Owen Hansen and his unreasonable demands along to Graciella. Arturo didn’t make that change as a favor to Graciella, and at the time he wondered how long it would be before Owen Hansen took his business elsewhere, but that didn’t happen because Owen Hansen and Graciella seemed to hit it off immediately.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For one thing, they were two sides of the same coin, and each had only one interest. For Owen it was himself. For Graciella, it was accumulating money. Graciella appreciated the fact that, in all their dealings, Owen—unlike some of her other clients—never once made a pass at her. She accepted the fact that he was a braggart, but there was plenty for him to brag about. He knew everything there was to know about computers. As far as Bitcoins were concerned, he was both a visionary and an early adopter who established one of the first and most efficient Bitcoin mining operations. That aspect of his business alone had turned him into a highly profitable client.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owen had other investment accounts in addition to his Bitcoin holdings. Graciella watched those without necessarily managing them, and was always amazed by the astonishing rates of return in which his accounts routinely outperformed everyone else’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But there was another part of Graciella’s dealings with Owen Hansen that never made it onto the books at Recursos Empresariales Internationales. While working there, Graciella had earned a well-deserved reputation as a logistics expert. Some of the arrangements she made—property transfers and aircraft purchases—were totally aboveboard. But many of the transactions she conducted, both for El Pescado and his associates and later on for Owen Hansen as well, were negotiated as a side business and conducted over the dark Web.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("When Owen was in town, they often went across the street to the Multiplaza Pacific Mall and had lunch at P.F. Chang’s. The restaurant was one Arturo was known to use as a launchpad for ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("his various work-based amorous adventures. Graciella didn’t care for the place, but since it was one of Owen’s favorites, too, she accompanied him there without objection.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At one of those lunches, on a day when the latest quarterly earnings reports had been posted earlier in the morning, she had noticed that, as usual, Owen’s investment accounts were the hands-down winners. “How do you do that?” she had inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find investments that consistently outperform everyone else’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not me,” he told her, “that’s Frigg.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Frigg?” she had asked. “Who’s Frigg?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked around the restaurant and when he was satisfied that no one was listening, he answered her question in a hushed voice. “Not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("who")]), _vm._v(" is Frigg,” he corrected with a smile and the easy confidence that came from having done business together for years. “You should be asking me "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("what")]), _vm._v(" is Frigg.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And?” Graciella interjected.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s an artificial intelligence, one that I created all by myself. She manages the collection of computers that do all my blockchain processing. She also manages my investment accounts. She’s so damned smart, that if I needed her to, I think she could help me get away with murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An artificial intelligence,” Graciella repeated. “Like a computer program, you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s actually a lot more than that,” Owen said. “Would you like to meet her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess,” Graciella replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owen reached into his pocket, pulled out a cell phone, and pressed the speaker button. “Good afternoon, Frigg,” he said. “I’d like you to meet a business associate of mine, Graciella Miramar. Would you mind saying hello?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m happy to meet her,” Frigg said. “Would she prefer to conduct our conversation in English or Spanish?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Graciella shot Owen a questioning look. “How does she know I speak Spanish?”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Frigg is privy to my correspondence,” he said. “I’m sure she’s noticed the location of your IP addresses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For both my work computer and my home computer?” Graciella asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Graciella, that was a disquieting thought. The computer she used at home and kept in the floor of her closet was something she preferred to keep quiet. Obviously Owen knew about it, and now so did Frigg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“English will be fine,” Graciella said aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good afternoon, Ms. Miramar,” Frigg said. “I’m happy to meet you. I hope you’re having a pleasant day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It struck Graciella as incredibly weird to be sitting there chatting away with a computer. She glanced questioningly at Owen who nodded encouragingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why are you called Frigg?” Graciella asked. “I’m not sure I’ve ever heard that name before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Hansen’s preferred nom de guerre is Odin, based on a widely revered Norse god bearing that same name. Frigg, sometimes called Freya, was Odin’s wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A nom de guerre,” Graciella repeated. “Does that mean you’re involved in a war of some kind?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m afraid,” said Frigg, “I’m not at liberty to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” Owen put in quickly. “Frigg has been sworn to secrecy on some aspects of our working relationship. I hope you don’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No problem,” Graciella said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there any further way for me to be of service?” Frigg asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Owen here—or should I say Odin—tells me that you’re the one responsible for the outstanding earnings in his investment accounts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe that is correct,” Frigg said. “As of this morning, the earnings rate across the board is 17.7 percent.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Which is very respectable,” Graciella said. “Enviable, in fact. How do you do that?”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“My job is to analyze all available data in the market, spot emerging trends, and select potential winners and losers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe he would allow me to borrow you from time to time,” Graciella suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frigg’s response was immediate. “I do not believe that would be a suitable course of action.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s all for now, Frigg,” Owen said, punching the speaker button and turning off the phone. “Sorry about that. She can be a little possessive on occasion and somewhat abrupt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can that be?” Graciella wondered aloud. “She’s a computer program.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A well-read computer program,” Owen said, “and one who prefers to have my undivided attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the first time Graciella spoke to Frigg, but it was not the last. After that, when Owen and Graciella were together, he often summoned the AI into the conversation, in much the same way a proud parent might trot out an exceptionally gifted child to show off the little one’s intellectual prowess. And every time it happened, Graciella came away even more impressed than she had been the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In her spare time, Graciella began to study the whole notion of artificial intelligence. The more she learned about AI in general and about Frigg in particular, the more Graciella could envision her future in a whole new way. Compared to Frigg and Odin, El Pescado and his drug cartel henchmen were truly a herd of lumbering dinosaurs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9baaac24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch07.vue
// module id = 90
// module chunks = 0